export enum UnitOfMeasure {
  Piece = 1,
  Set = 2,
  Meter = 3,
  Foot = 4,
  Inches = 5,
  Liter = 6,
  Roll = 7
}

export enum Status {
  New = 40,
  InProgress = 50,
  ForBarcoding = 60,
  ForApproval = 80,
  Rejected = 90,
  Processed = 100,
  ForDeletion = 1
}

export enum USERTYPE {
  Admin = 'Admin',
  User = 'User',
  Cashier = 'Cashier',
  SalesStaff = 'SalesStaff',
  ProcurementLead = 'ProcurementLead',
  ProcurementStaff = 'ProcurementStaff',
  OnlineSalesLead = 'OnlineSalesLead',
  OnlineSalesStaff = 'OnlineSalesStaff',
  Mechanic = 'Mechanic',
  ServiceAdvisor = 'ServiceAdvisor',
  WarehouseLead = 'WarehouseLead',
  WarehouseStaff = 'WarehouseStaff',
  AccountingStaff = 'AccountingStaff',
  AccountingLead = 'AccountingLead',
  HumanResourceStaff = 'HumanResourceStaff'
}

export enum SalesStatus {
  New = 1,
  InProgress = 5,
  Submitted = 10,
  Today = 2
}

export enum PaymentMethod {
  Cash = 1,
  GCash = 2,
  Maya = 3,
  Unionbank = 4,
  BDO = 5,
  Card = 6
}

export enum ProcurementReturnsStatus {
  New = 'New',
  Reviewed = 'Reviewed',
  ReturnedToSupplier = 'ReturnedToSupplier',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled'
}

export enum WorkDayType {
  RegularDay = 1,
  RestDay = 2,
  RegularHoliday = 3,
  SpecialNonWorkingDay = 4,
  SpecialWorkingHoliday = 5,
  DoubleHoliday = 6
}

export enum LeaveStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4
}

export const LEAVE_STATUS_OPTIONS: { value: LeaveStatus; label: string }[] = [
  { value: LeaveStatus.Pending, label: 'Pending' },
  { value: LeaveStatus.Approved, label: 'Approved' },
  { value: LeaveStatus.Rejected, label: 'Rejected' },
  { value: LeaveStatus.Cancelled, label: 'Cancelled' }
];

export const getLeaveStatusLabel = (status: LeaveStatus): string =>
  LEAVE_STATUS_OPTIONS.find(option => option.value === status)?.label ??
  'Unknown';

export enum CashAdvanceStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Cancelled = 4
}

export const CASH_ADVANCE_STATUS_OPTIONS: {
  value: CashAdvanceStatus;
  label: string;
}[] = [
  { value: CashAdvanceStatus.Pending, label: 'Pending' },
  { value: CashAdvanceStatus.Approved, label: 'Approved' },
  { value: CashAdvanceStatus.Rejected, label: 'Rejected' },
  { value: CashAdvanceStatus.Cancelled, label: 'Cancelled' }
];

export const getCashAdvanceStatusLabel = (status: CashAdvanceStatus): string =>
  CASH_ADVANCE_STATUS_OPTIONS.find(option => option.value === status)?.label ??
  'Unknown';

export enum OvertimeRequestStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3
}

export const OVERTIME_REQUEST_STATUS_OPTIONS: {
  value: OvertimeRequestStatus;
  label: string;
}[] = [
  { value: OvertimeRequestStatus.Pending, label: 'Pending' },
  { value: OvertimeRequestStatus.Approved, label: 'Approved' },
  { value: OvertimeRequestStatus.Rejected, label: 'Rejected' }
];

export const getOvertimeRequestStatusLabel = (
  status: OvertimeRequestStatus
): string =>
  OVERTIME_REQUEST_STATUS_OPTIONS.find(option => option.value === status)
    ?.label ?? 'Unknown';

export const WORK_DAY_TYPE_OPTIONS: { value: WorkDayType; label: string }[] = [
  { value: WorkDayType.RegularDay, label: 'Regular Day' },
  { value: WorkDayType.RestDay, label: 'Rest Day' },
  { value: WorkDayType.RegularHoliday, label: 'Regular Holiday' },
  { value: WorkDayType.SpecialNonWorkingDay, label: 'Special Non-Working Day' },
  { value: WorkDayType.SpecialWorkingHoliday, label: 'Special Working Holiday' },
  { value: WorkDayType.DoubleHoliday, label: 'Double Holiday' }
];

export const getWorkDayTypeLabel = (dayType: WorkDayType): string =>
  WORK_DAY_TYPE_OPTIONS.find(option => option.value === dayType)?.label ??
  'Regular Day';
